// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oldProduction[data-v-19ed4da4]{width:100%;max-height:120px;overflow-x:hidden}.oldProduction[data-v-19ed4da4] .el-select__tags{max-height:120px!important}", ""]);
// Exports
module.exports = exports;
